import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M8.06 12.33 8 12.4l-.06-.07Zm2.27-.24L8.55 14a.75.75 0 0 1-1.1 0l-1.78-1.91a.75.75 0 0 1 .55-1.26h1V9a.75.75 0 1 1 1.5 0v1.82h1a.75.75 0 0 1 .55 1.26Zm-2.27.24h-.12l.06.07Zm1.59-10A5 5 0 0 0 5 5.51a.82.82 0 0 0-.22 0 3.45 3.45 0 0 0-1.9 6.33.79.79 0 0 0 .42.12.74.74 0 0 0 .62-.34.74.74 0 0 0-.21-1A1.94 1.94 0 0 1 4.78 7a1.55 1.55 0 0 1 .48.07.7.7 0 0 0 .25 0h.09a.76.76 0 0 0 .65-.56 3.51 3.51 0 1 1 6 3.24.75.75 0 0 0 0 1.06.69.69 0 0 0 .5.2.76.76 0 0 0 .56-.24 5 5 0 0 0-3.7-8.41Z';
const draw24px =
  'M15.56,18.48l-3,3.25a.7.7,0,0,1-.29.19.7.7,0,0,1-.52,0,.7.7,0,0,1-.29-.19l-3-3.25a.75.75,0,0,1,1.1-1l1.71,1.84V13.64a.75.75,0,1,1,1.5,0v5.67l1.71-1.84a.74.74,0,0,1,1.06,0A.73.73,0,0,1,15.56,18.48Zm-.76-15A7.94,7.94,0,0,0,7.28,8.8a5.84,5.84,0,0,0-.73-.05A5.3,5.3,0,0,0,4.23,18.82a.78.78,0,0,0,.33.07.75.75,0,0,0,.33-1.42,3.77,3.77,0,0,1-2.14-3.42,3.81,3.81,0,0,1,4.76-3.68.65.65,0,0,0,.31,0,.75.75,0,0,0,.72-.57,6.45,6.45,0,1,1,10,6.84.75.75,0,0,0-.18,1.05A.77.77,0,0,0,19,18a.69.69,0,0,0,.43-.14A8,8,0,0,0,14.8,3.44Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const CloudDownArrowIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'cloudDownArrow')) as IconWithRender;

CloudDownArrowIcon.displayName = 'CloudDownArrowIcon';
CloudDownArrowIcon.propTypes = Icon.propTypes;
CloudDownArrowIcon.renderIcon = (props) => <CloudDownArrowIcon {...props} />;
export default CloudDownArrowIcon;
